import { render, staticRenderFns } from "./GroupDetails.vue?vue&type=template&id=d50620f4&scoped=true"
import script from "./GroupDetails.vue?vue&type=script&lang=ts"
export * from "./GroupDetails.vue?vue&type=script&lang=ts"
import style0 from "./GroupDetails.vue?vue&type=style&index=0&id=d50620f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50620f4",
  null
  
)

export default component.exports